import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import { Modal, IconButton, Autocomplete } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { RiArrowDropDownLine } from 'react-icons/ri';
import { BsTelephoneFill } from 'react-icons/bs';
import { MdEmail } from 'react-icons/md';
import Divider from '@mui/material/Divider';
import { makeStyles } from '@mui/styles';
import user_icon from '../../../../public/assets/user_icon.jpg';
import logo_between from '../../../../public/assets/logo-white.jpeg';
import { Card, CardContent, Checkbox } from '@mui/material';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import LeadService from '../../../core/services/leadsService';
import toast from 'react-hot-toast';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import logoICA from '../../../../public/assets/icoonectICA.png';
// import dayjs from 'dayjs';
import InputAdornment from '@mui/material/InputAdornment';
import EventIcon from '@mui/icons-material/Event';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
// import moment from 'moment';
import { useDateTime } from '../../../pages/ContextDateandTime/DateTimeContext';
import { useDispatch, useSelector } from 'react-redux';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { CLOSE_LEAD_MODEL, CLOSE_RE_ASSING_MODAL } from '../../../core/store/slice/icaSlice';
import Avatar from '@mui/material/Avatar';
import ChatModule from './ChatModule';
import NoteAltIcon from '@mui/icons-material/NoteAlt';
import AddIcCallIcon from '@mui/icons-material/AddIcCall';
import GooglePlacesAutocomplete, { geocodeByPlaceId, getLatLng } from 'react-google-places-autocomplete';
import { Loader } from '@googlemaps/js-api-loader';
import dayjs from 'dayjs';
import UpdateIcaMeeting from '../ICaMap/UpdateIcaMeeting';
import { Chip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import FilterListIcon from '@mui/icons-material/FilterList';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
    '& .MuiDialog-paper': {
        borderRadius: '20px', // Set your desired border radius here
    },
}));
const useStyles = makeStyles({
    card: {
        width: 720,
        height: 'auto',
        backgroundColor: '#84ADD6 !important',
        borderRadius: '22px',
        boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
    },
    cardOne: {
        width: 572,
        height: 'auto',
        borderRadius: '8px !important',
        backgroundColor: '#84ADD6 !important',
        boxShadow: 'rgba(0, 0, 0, 0.35) 0px 5px 15px',
    },
});

const CustomerLeadProfile = ({
    selectedProperties,
    handleRequestedAgents,
    handleAssignLead,
    getLeads,
    setSelectedProperties,
    searchValue,
    setProfileAgent,
    selectedTags,
    setSelectedTags,
    tags,
    setTags,
    stopGetLeads,
}) => {
    const classes = useStyles();
    const { selectedDate, setSelectedDate, selectTime, setSelectTime } = useDateTime();
    const [displayDate, setDisplayDate] = useState('');
    const [open, setOpen] = useState(false);
    const [showPhoneNumber, setShowPhoneNumber] = useState(false);
    const userData = JSON.parse(localStorage.getItem('user'));
    const [loading, setLoading] = React.useState(false);
    const [openLocation, setOpenLocation] = React.useState(false);
    const [updateStatusNotes, newUpdateStatusNotes] = React.useState('');
    const [updateStatusValue, newUpdateStatusValue] = React.useState('');
    const [saveNoteModel, setSaveNoteModel] = useState(false);
    const [saveNoteStatus, setSaveNoteModelStatus] = React.useState('');
    const [zoomLevel, setZoomLevel] = useState(13);
    const [openNullModal, setOpenNullModal] = useState(false);
    const [PreferredRegions, setPreferredRegions] = useState([null]);
    const [selectedLocation, setSelectedLocation] = useState();
    const [googleLocation, setGoogleLocation] = useState(null);
    const [longitude, setLongitude] = useState(null);
    const [latitude, setLatitude] = useState(null);
    const [openMeetingModal, setOpenMeetingModal] = useState(false);
    const [sortOrder, setSortOrder] = useState('asc');
    const [menuAnchor, setMenuAnchor] = useState(null);
    const [showAllReplies, setShowAllReplies] = React.useState(false);

    const LoginUserId = userData?.user.id;
    const LoginUsername = `${userData.user?.name} ${userData.user?.last_name}`;
    // To store tags data from API

    console.log(LoginUserId, 'loginID');
    const [anchorEl, setAnchorEl] = useState(null);
    const { user } = useSelector((state) => state.auth);

    const loader = new Loader({
        apiKey: import.meta.env.VITE_GOOGLE_API_KEY,
        version: 'weekly',
        libraries: ['places'],
    });

    const handlePlaceSelect = async (value) => {
        try {
            setGoogleLocation(value);
            const results = await geocodeByPlaceId(value?.value?.place_id);
            if (results && results.length > 0) {
                const { lat, lng } = await getLatLng(results[0]);
                setLatitude(lat);
                setLongitude(lng);
            }
        } catch (error) {
            console.error('Error fetching geolocation:', error);
        }
    };

    loader.load().then(() => {
        console.log('Google Maps API loaded');
    });

    const menuItems = [
        { value: 'active', text: 'Active' },
        { value: 'new', text: 'New' },
        { value: 'attempting_contact', text: 'Attempting Contact' },
        { value: 'spoke_with_customer_new', text: 'Spoke with customer New' },
        { value: 'spoke_with_customer', text: 'Spoke with customer' },
        { value: 'appointment_set', text: 'Appointment Set' },
        { value: 'met_with_customer', text: 'Met with customer' },
        { value: 'showing_homes', text: 'Showing Homes' },
        { value: 'submitting_offers', text: 'Submitting Offers' },
        { value: 'under_contract_escrow', text: 'Under Contract/Escrow' },
        { value: 'bamfam', text: 'BAMFAM' },
        { value: 'nurture', text: 'Nurture Before sale' },
        { value: 'nurture_after_sale', text: 'Nurture After Sale' },
        { value: 'closed', text: 'Sale Closed' },
        { value: 'rejected', text: 'Rejected' },
        { value: 'not_interested', text: 'Not Interested' },
        { value: 'refinance_referral', text: 'Refinance Referral' },
        { value: 'personal_lead', text: 'Personal Lead' },
        { value: 'agent', text: 'Agent' },
        { value: 'bad_lead', text: 'Bad Lead' },
        { value: 'buy_side_contract', text: 'Buy Side Contract' },
        { value: 'dnc', text: 'DNC' },
        { value: 'buyer_broker_signed', text: 'Buyer Broker Signed' },
        { value: 'cancelled', text: 'Cancelled' },
        { value: 'valuation_appointment', text: 'Valuation Appointment' },
        { value: 'listing_signed', text: 'Listing Signed' },
        { value: 'listing_appointment', text: 'Listing Appointment' },
        { value: 'follow_up', text: 'Follow Up' },
        { value: 'list_under_contract', text: 'List Under Contract' },
    ];

    const handleClick = (event) => {
        // const status = GetLeadsData?.status;
        // if(status == 'spoke_with_customer_new'){
        //     toast.error("You can't update any status without assigning to real estate agent!.")
        //     return
        // }
        setAnchorEl(event.currentTarget);
    };

    const handleUpdateStatus = async (value) => {
        setAnchorEl(null);
        const Lead_id = GetLeadsData?.id;
        const LoginUserId = user?.id;
        const newUpdateStatusFrontEnd = menuItems.find((item) => item.value === value)?.text || '';
        newUpdateStatusNotes(newUpdateStatusFrontEnd);
        newUpdateStatusValue(value);
        const appointmentSet = GetLeadsData?.appointment_set;
        const status = GetLeadsData?.status;
        const selectedPropertiesId = GetLeadsData?.id;
        if (appointmentSet == 0) {
            return toast.error("You can't update any status without assigning to real estate agent.");
        } else if (status === 'rejected' || (status === 'closed' && value === 'appointment_set')) {
            return toast.error("Rejection of Update status.You can't proceed further!.");
        } else if (appointmentSet == 1 && value === 'appointment_set') {
            return toast.error('The status is already Assigned');
        } else if (value === 'appointment_set') {
            return toast.error('The status is already Assigned.');
        } else if (status === value) {
            return toast.error('Select another status and proceed later!');
        } else if (status === 'rejected') {
            return toast.error("Rejection of Update status.You can't proceed further!.");
        } else if (status === 'closed') {
            return toast.error("Rejection of Update status.You can't proceed further!.");
        } else {
            const note = `has changed status from "${formattedStatus.props.children}" to "${updateStatusNotes}" with this note "${saveNoteStatus}"`;
            if (!saveNoteModel) {
                setSaveNoteModel(true);
            } else {
                if (!saveNoteStatus.trim()) {
                    return toast.error('Please add a note for complete customer profile details.');
                }
                setSaveNoteModel(false);
                await NewUpdateStatus(value, Lead_id, LoginUserId, selectedPropertiesId, note, updateStatusValue);
            }
        }
    };

    const NewUpdateStatus = async (updateStatusValue, Lead_id, LoginUserId, selectedPropertiesId, note) => {
        try {
            const res = await LeadService.updateStatus(updateStatusValue, Lead_id, LoginUserId);
            if (res?.data?.success) {
                toast.success(res?.data?.message);
                await handleAgentInternalNote(selectedPropertiesId, note);
                await getLeadsDetails(LeadId);
                setSaveNoteModelStatus('');
                return;
            }
        } catch (error) {
            console.error(error.message);
            toast.error(error?.message);
        }
    };

    const handleZoomIn = () => {
        setZoomLevel((prevZoom) => prevZoom + 1);
    };

    const handleZoomOut = () => {
        setZoomLevel((prevZoom) => Math.max(1, prevZoom - 1));
    };
    const handleCloseModalProperties = () => {
        setSelectedProperties(null);
        setOpen(false);
    };

    const icaStore = useSelector((state) => state.ica);

    useEffect(() => {
        if (icaStore.leadModal.open) {
            setOpen(true);
            setTimeout(() => {
                dispatch(CLOSE_LEAD_MODEL());
            }, 1000);
        }
    }, [icaStore.leadModal.open]);

    useEffect(() => {
        if (icaStore.locationModal.open) {
            setOpen(false);
        }
        setOpenLocation(icaStore.locationModal.open);
    }, [icaStore.locationModal.open]);

    useEffect(() => {
        if (selectedProperties && !icaStore.locationModal.open && !loading) {
            setOpen(true);
            setLoading(true);
        } else {
            setOpen(false);
        }
    }, [selectedProperties]);

    const handleClose = async () => {
        setSelectedProperties(null);
        setOpen(false);
    };

    const handleClickOpenLocationModel = () => {
        stopGetLeads();
        stopGetLeads();
        setOpenLocation(true);
        setOpen(false);
        setProfileAgent(false);
    };
    const dispatch = useDispatch();
    const handleCloseLocation = async () => {
        setOpenLocation(false);
        setSelectedDate('');
        setSelectTime('');
        setTags([]);
        setSelectedTags([]);
        dispatch(CLOSE_RE_ASSING_MODAL());
        await getLeads(searchValue);
    };

    const [GetLeadsData, setGetLeadsData] = React.useState('');
    const [LeadId, setLeadId] = React.useState('');
    console.log('takeId', GetLeadsData?.id);
    useEffect(() => {
        if (selectedProperties?.id) {
            setLeadId(selectedProperties.id);
        }
    }, [selectedProperties?.id]);

    const getLeadsDetails = async (LeadId) => {
        try {
            setLoading(true);
            const res = await LeadService.getLeadDetails(LeadId);
            if (res?.data?.success === true) {
                setGetLeadsData(res?.data?.lead);
            }
        } catch (error) {
            console.error(error);
            toast.error(error?.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (LeadId) {
            getLeadsDetails(LeadId);
            GetIcaLeadNotes(LeadId);
        }
    }, [LeadId]);
    // clicked on email icon go to email
    const email = GetLeadsData?.email;
    const gmailComposeUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${email}`;

    //prefered location drop down
    const [assignRadio, SetAssignRadio] = React.useState('0');

    const hanldeAssignRadio = (event) => {
        SetAssignRadio(event.target.value);
    };
    const [notes, setNotes] = useState();

    const [displayNotes, setDisplayNotes] = useState([]);
    useEffect(() => {
        if (GetLeadsData?.note?.notes) {
            setDisplayNotes(GetLeadsData?.note?.notes);
        }
    }, [GetLeadsData]);

    const handleDisplayNotes = () => {
        if (notes) {
            const currentDate = new Date();
            const month = currentDate.toLocaleString('en-US', {
                month: '2-digit',
            });
            const day = currentDate.toLocaleString('en-US', {
                day: '2-digit',
            });
            const year = currentDate.toLocaleString('en-US', {
                year: 'numeric',
            });
            const time = currentDate.toLocaleString('en-US', {
                hour: '2-digit',
                minute: '2-digit',
                hour12: true,
            });
            const formattedTimestamp = `${month}-${day}-${year} ${time} `;

            const newNote = {
                content: notes, // Match the property name used in rendering
                creatorName: LoginUsername || '', // Or retrieve dynamically
                createTime: new Date().toISOString(),
                timestamp: formattedTimestamp,
            };
            setDisplayNotes([...displayNotes, newNote]);
            setNotes('');
        }
    };

    const handleAgentInternalNote = async (selectedPropertiesId, note) => {
        try {
            handleDisplayNotes();
            const currentDate = new Date();
            const month = currentDate.toLocaleString('en-US', {
                month: '2-digit',
            });
            const day = currentDate.toLocaleString('en-US', {
                day: '2-digit',
            });
            const year = currentDate.toLocaleString('en-US', {
                year: 'numeric',
            });
            const time = currentDate.toLocaleString('en-US', {
                hour: '2-digit',
                minute: '2-digit',
                hour12: true,
            });
            const timestamp = `${month}-${day}-${year} ${time} `;
            const res = await LeadService.icaAgentInternalNote(selectedPropertiesId, note, timestamp);
            if (res?.data?.success === true) {
                toast.success(res?.data?.message);
                await getLeads(searchValue);
                return;
            }
        } catch (error) {
            console.error(error);
            toast.error(error?.message);
        }
    };

    const formatDateToDisplay = (isoDate) => {
        const date = new Date(isoDate);
        return date.toLocaleDateString('en-US', { month: 'short', day: '2-digit', year: 'numeric' });
    };
    const handleChangeDate = (e) => {
        setSelectedDate(e.target.value);
        const formattedDisplayDate = formatDateToDisplay(e.target.value);
        setDisplayDate(formattedDisplayDate);
    };
    const getTomorrowsDate = () => {
        const today = new Date();
        const tomorrow = new Date(today);
        tomorrow.setDate(tomorrow.getDate() + 0);
        return tomorrow.toISOString().slice(0, 10);
    };
    const tomorrowsDate = getTomorrowsDate();

    const handleTimeChange = (time) => {
        setSelectTime(time);
    };

    const getPreferredRegions = async () => {
        try {
            const res = await LeadService.getPreferedRegions();
            if (res?.data?.success === true) {
                setPreferredRegions(res?.data?.data);
                return;
            }
        } catch (error) {
            console.error(error);
            toast.error(error?.message);
        }
    };

    useEffect(() => {
        getPreferredRegions();
    }, []);

    const handleFindNearestAgents = (selectedLocation, GetLeadsDataId, googleLocation, latitude, longitude, selectedTags) => {
        const currentDate = new Date();
        currentDate.setHours(0, 0, 0, 0);
        const selected = new Date(selectedDate);
        selected.setHours(0, 0, 0, 0);
        const now = dayjs();
        const selectedTime = dayjs(selectTime);
        if (selectedDate === undefined || selectedDate === null || selectedDate === '') {
            toast.error('Please select date');
            return;
        } else if (selectTime === undefined || selectTime === null || selectTime === '') {
            toast.error('Please select time');
            return;
        } else if (selected.getTime() === currentDate.getTime() && selectedTime.isBefore(now)) {
            toast.error('Please select the current time or a future time.');
            return;
        } else if (selected < currentDate) {
            toast.error('Please select a future date!');
            return;
        } else if (selectedLocation == null && assignRadio === '1') {
            toast.error('Please select the preferred location');
            return;
        } else if (googleLocation == null) {
            toast.error('Please enter the meeting location');
            return;
        } else {
            setOpenLocation(false);
        }

        dispatch(CLOSE_RE_ASSING_MODAL());
        handleAssignLead(selectedLocation, GetLeadsDataId, selectTime, selectedDate, googleLocation, latitude, longitude, selectedTags);
    };
    const mapStatusToFormatAndColor = (status) => {
        const statusMapping = {
            active: { text: ' ● New ', color: '#00000F' },
            new: { text: ' ● New ', color: '#00000F' },
            attempting_contact: { text: ' ● Attempting Contact ', color: '#9B0000' },
            spoke_with_customer_new: { text: ' ● New ', color: '#00000F' },
            spoke_with_customer: { text: ' ● Spoke with customer ', color: '#00BF2A' },
            appointment_set: { text: ' ● Appointment Set ', color: '#00BF2A' },
            met_with_customer: { text: ' ● Met with customer ', color: '#7400C2' },
            showing_homes: { text: ' ● Showing Homes ', color: '#ED7DB1' },
            submitting_offers: { text: ' ● Submitting Offers ', color: '#6EA478' },
            under_contract_escrow: { text: ' ● Under Contract/Escrow ', color: '#4C489B' },
            bamfam: { text: ' ● BAMFAM ', color: '#6691CB' },
            nurture: { text: ' ● Nurture Before sale ', color: '#9B5B00' },
            nurture_after_sale: { text: ' ● Nurture After Sale ', color: '#9B5B5B' },
            closed: { text: ' ●  Sale Closed ', color: '#F17105' },
            rejected: { text: ' ● Rejected ', color: '#ED0423' },
            not_interested: { text: ' ● Not Interested ', color: '#ebc3c3' },
            refinance_referral: { text: ' ● Refinance Referral ', color: '#9B5B5B' },
            personal_lead: { text: ' ● Personal Lead ', color: '#9B5B5B' },
            agent: { text: ' ● Agent ', color: 'white' },
            bad_lead: { text: ' ● Bad Lead ', color: '#2e1414' },
            buy_side_contract: { text: ' ● Buy Side Contract ', color: '#9B5B5B' },
            dnc: { text: ' ● DNC ', color: '#9B5B5B' },
            buyer_broker_signed: { text: ' ● Buyer Broker Signed ', color: '#FFFFFF' },
            cancelled: { text: ' ● Cancelled ', color: '#FFFFFF' },
            valuation_appointment: { text: ' ● Valuation Appointment ', color: '#FFFFFF' },
            listing_signed: { text: ' ● Listing Signed ', color: '#FFFFFF' },
            listing_appointment: { text: ' ● Listing Appointment ', color: '#FFFFFF' },
            follow_up: { text: ' ● Follow Up ', color: '#FFFFFF' },
        };

        const divBackgroundColors = {
            active: '#e9e4e4',
            new: '#e9e4e4',
            attempting_contact: '#ababef',
            spoke_with_customer_new: '#ababef',
            spoke_with_customer: '#bee5c6',
            appointment_set: '#bee5c6',
            met_with_customer: '#d9c2e9',
            showing_homes: '#f9d5e6',
            submitting_offers: '#bbe3c2',
            under_contract_escrow: '#c1bfed',
            bamfam: '#edeff5',
            nurture: '#f9deb8',
            nurture_after_sale: '#e7c612',
            closed: '#fff0e3',
            rejected: '#fbdfe2',
            not_interested: '#df3271',
            refinance_referral: '#e7e2c7',
            agent: '#5500CC',
            personal_lead: '##fff',
            bad_lead: '#c12f0d',
            buy_side_contract: '#e7c612',
            dnc: '#A87BFF',
            buyer_broker_signed: '#FABED4',
            cancelled: '#4C489B',
            valuation_appointment: '#7D9B00',
            listing_signed: '#C29800',
            listing_appointment: '#CB5935',
            follow_up: '#2e7a5c',
        };
        const divBorder = {
            active: '1px solid black',
            new: '1px solid black',
            attempting_contact: '1px solid #9B0000',
            spoke_with_customer_new: '1px solid #00000F',
            spoke_with_customer: '1px solid #00BF2A',
            appointment_set: '1px solid #00BF2A',
            met_with_customer: '1px solid #7400C2',
            showing_homes: '1px solid #ED7DB1',
            submitting_offers: '1px solid #6EA478',
            under_contract_escrow: '1px solid #4C489B',
            bamfam: '1px solid #6691CB',
            nurture: '1px solid #9B5B00',
            nurture_after_sale: '1px solid #9B5B5B',
            closed: '1px solid #F17105',
            rejected: '1px solid #ED0423',
            not_interested: '1px solid #a9199f',
            refinance_referral: '1px solid #a99497',
            agent: '1px solid #5500CC',
            personal_lead: '1px solid #a99497',
            bad_lead: '1px solid #5c433b',
            buy_side_contract: '1px solid #9B5B5B',
            dnc: '1px solid #9B5B5B',
            buyer_broker_signed: '1px solid #FABED4',
            cancelled: '1px solid #4C489B',
            valuation_appointment: '1px solid #7D9B00',
            listing_signed: '1px solid #483c10',
            listing_appointment: '1px solid #CB5935',
            follow_up: '1px solid #2d6f55',
        };

        const { text, color } = statusMapping[status] || { text: status, color: '#000000' };
        const divBackgroundColor = divBackgroundColors[status] || 'transparent';
        const border = divBorder[status] || '1px solid black';
        return {
            formattedStatus: <span style={{ color }}>{text}</span>,
            divStyle: {
                background: divBackgroundColor,
                border,
            },
        };
    };

    const { formattedStatus, divStyle } = mapStatusToFormatAndColor(GetLeadsData?.status);
    const formatDate = (timestamp) => {
        const date = new Date(timestamp);
        const formattedDate = `${date.toLocaleDateString()} ${date.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })}`;
        return formattedDate;
    };
    const handleNoteModalClose = async () => {
        setSaveNoteModel(false);
        await getLeadsDetails(LeadId);
    };

    const handleIconClick = () => {
        setShowPhoneNumber(!showPhoneNumber);
        setOpenNullModal(true);
    };

    const capitalizeFirstLetter = (string) => {
        if (!string) return '';
        return string.charAt(0).toUpperCase() + string.slice(1);
    };

    // Remove underscores from updateStatusValue and capitalize the first letter
    const formattedStatusValue = capitalizeFirstLetter(updateStatusValue.replace(/_/g, ' '));

    const adjustTimeBasedOnOffsetForReceivedData = (dateString, offsetInHours) => {
        const date = new Date(dateString);
        // Convert to UTC and then apply offset
        const utcDate = new Date(date.getTime() + date.getTimezoneOffset() * 60000);
        utcDate.setHours(utcDate.getHours() + offsetInHours);
        return utcDate;
    };

    const getUserOffset = () => {
        const offset = localStorage.getItem('userOffset');
        return offset ? parseFloat(offset) : 0;
    };

    const formatDateTime = (date) => {
        const options = { year: 'numeric', month: 'long', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: true };
        return date.toLocaleDateString(undefined, options).replace(',', '');
    };
    const userOffset = getUserOffset();
    const adjustedDate = adjustTimeBasedOnOffsetForReceivedData(GetLeadsData?.created_at, userOffset);

    const formattedDate = adjustedDate ? formatDateTime(adjustedDate) : 'No date available';
    const handleChangeTags = (event, newValue) => {
        const selectedIDs = newValue ? newValue.map((tag) => tag?.title) : [];
        setSelectedTags(selectedIDs);
    };
    const getAllTags = async () => {
        try {
            const res = await LeadService.getTags();
            if (res.data.success) {
                const data = Array.isArray(res.data.data) ? res.data.data : [];
                const formattedTags = data.map((tag) => ({
                    title: tag?.tag ?? 'Unknown',
                    id: tag?.id ?? null,
                }));
                setTags(formattedTags);
            }
        } catch (error) {
            toast.error(error.message);
        }
    };

    useEffect(() => {
        getAllTags();
    }, []);
    const handleClickOpenMeetingModel = () => {
        stopGetLeads();
        setOpenMeetingModal(true);
        setOpen(false);
        setProfileAgent(false);
    };
    const GetIcaLeadNotes = async (LeadId) => {
        try {
            const res = await LeadService.GetLeadNote(LeadId);
            if (res?.data?.success) {
                const formattedNotes = res?.data?.notes.map((note) => {
                    return {
                        id: note?.id,
                        content: note?.note,
                        creatorName: note?.creatorName,
                        createTime: note?.created_at,
                        replies: note?.replies || [],
                    };
                });
                setDisplayNotes(formattedNotes);
            }
        } catch (error) {
            console.error(error.message);
            toast.error(error.message);
        }
    };
    const handleSort = (order) => {
        setSortOrder(order);
        const sortedNotes = [...displayNotes].sort((a, b) => {
            return order === 'asc' ? a.creatorName.localeCompare(b.creatorName) : b.creatorName.localeCompare(a.creatorName);
        });
        setDisplayNotes(sortedNotes);
        setMenuAnchor(null);
    };

    const tagsOne = GetLeadsData?.tag ? GetLeadsData.tag.split(', ') : [];

    const format12HourTime = (timeString) => {
        if (!timeString) return '';
        let dateObj = new Date(timeString);
        if (isNaN(dateObj.getTime())) {
            const today = new Date();
            const [hours, minutes] = timeString.split(':');
            dateObj = new Date(today.getFullYear(), today.getMonth(), today.getDate(), hours, minutes);
        }

        return dateObj.toLocaleString('en-US', {
            hour: 'numeric',
            minute: 'numeric',
            hour12: true,
        });
    };
    useEffect(() => {
        
        // If there's already an address in GetLeadsData, set it as the initial value
        if (GetLeadsData?.display_address) {
            setGoogleLocation({
                label: GetLeadsData.display_address,
                value: { place_id: '' }, // Assuming place_id is not needed for initial setup, you can update it later
            });
        }
    
        // Set the initial latitude and longitude from GetLeadsData if available
        if (GetLeadsData?.buyer_latitude && GetLeadsData?.buyer_longitude) {
            setLatitude(GetLeadsData.buyer_latitude);
            setLongitude(GetLeadsData.buyer_longitude);
        }
    }, [GetLeadsData]);  // This effect runs whenever GetLeadsData changes
    
    
    return (
        <>
            {loading ? (
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '100vh',
                    }}
                >
                    <CircularProgress sx={{ color: 'red' }} />
                </div>
            ) : (
                <BootstrapDialog
                    aria-labelledby="customized-dialog-title"
                    open={open}
                >
                    <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                        Lead Details
                    </DialogTitle>
                    <IconButton
                        aria-label="close"
                        onClick={handleClose}
                        sx={(theme) => ({
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: theme.palette.grey[500],
                        })}
                    >
                        <CloseIcon />
                    </IconButton>

                    <DialogContent dividers>
                        <div style={{ marginTop: '0px', position: 'relative' }}>
                            <div>
                                {/* google image */}
                                <img
                                    src={`https://maps.googleapis.com/maps/api/staticmap?zoom=${zoomLevel}&size=720x220&maptype=roadmap&center=${GetLeadsData?.buyer_latitude},${GetLeadsData?.buyer_longitude}&key=AIzaSyC9saN_UXZFij-RjWWX9drQEQSZw5PaPcA`}
                                    alt="Static map"
                                    style={{
                                        width: '720px',
                                        height: '220px',
                                        borderRadius: '22px',
                                        boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                                    }}
                                />
                                <div style={{ position: 'absolute', top: 4, right: 19 }}>
                                    <Button
                                        onClick={handleZoomIn}
                                        variant="outlined"
                                        style={{ fontSize: '12px', fontWeight: '600', background: 'white', color: 'black' }}
                                    >
                                        <AddIcon />
                                    </Button>
                                    <Button
                                        onClick={handleZoomOut}
                                        variant="outlined"
                                        style={{ fontSize: '12px', fontWeight: '600', background: 'white', color: 'black' }}
                                    >
                                        <RemoveIcon />
                                    </Button>
                                </div>
                            </div>
                            <div
                                style={{
                                    position: 'absolute',
                                    top: '53px',
                                    left: '50%',
                                    transform: 'translateX(-50%)',
                                    zIndex: 10,
                                    display: 'flex',
                                    alignItems: 'center',
                                    borderRadius: '4px',
                                    padding: '5px',
                                }}
                            >
                                <img
                                    src={logo_between}
                                    alt=""
                                    style={{ width: '44px', height: '44px', borderRadius: '24px', border: '1px solid gray' }}
                                />
                            </div>
                        </div>
                        <Box>
                            <div style={{ display: 'flex', marginTop: '15px', justifyContent: 'space-between' }}>
                                <div style={{ display: 'grid' }}>
                                    <div style={{ display: 'flex', gap: '4px' }}>
                                        <div
                                            style={{
                                                marginTop: '1px',
                                            }}
                                        >
                                            <Divider
                                                style={{
                                                    border: GetLeadsData?.assignto?.last_login ? '3px solid green' : '3px solid red',
                                                    backgroundColor: GetLeadsData?.assignto?.last_login ? 'green' : 'red', // Conditionally change background color
                                                    transform: 'rotate(180deg)',
                                                    height: '25px',
                                                    borderRadius: '10px',
                                                }}
                                            />
                                        </div>
                                        <div>
                                            <span style={{ fontSize: '22px', fontWeight: '700', color: '#606060' }}>
                                                {GetLeadsData?.first_name} {GetLeadsData?.last_name}
                                            </span>
                                        </div>
                                    </div>
                                    <div style={{ width: '300px', height: 'auto' }}>
                                        <span style={{ fontSize: '12px', color: '#332f2f', fontWeight: '500', }}>🏠 : {GetLeadsData?.display_address}</span>
                                    </div>
                                </div>
                                <div style={{ display: 'flex', gap: '5px' }}>
                                    <div
                                        style={{
                                            ...divStyle,
                                            borderRadius: '10px',
                                            padding: '3px',
                                            width: 'auto',
                                            display: 'flex',
                                            gap: '2px',
                                            marginRight: '-14px',
                                            height: '35px',
                                        }}
                                    >
                                        <div style={{ marginTop: '3px', cursor: 'pointer' }} onClick={handleClick}>
                                            {formattedStatus}
                                        </div>
                                    </div>

                                    <RiArrowDropDownLine
                                        onClick={handleClick}
                                        style={{
                                            fontSize: '36px',
                                            cursor: 'pointer',
                                        }}
                                    />
                                    <Menu
                                        id="demo-positioned-menu"
                                        aria-labelledby="demo-positioned-button"
                                        anchorEl={anchorEl}
                                        open={Boolean(anchorEl)}
                                        onClose={() => setAnchorEl(null)}
                                        anchorOrigin={{
                                            vertical: 'bottom',
                                            horizontal: 'left',
                                        }}
                                        transformOrigin={{
                                            vertical: 'top',
                                            horizontal: 'right',
                                        }}
                                        style={{ height: '300px' }}
                                    >
                                        {menuItems.map((menuItem) => (
                                            <MenuItem key={menuItem?.value} onClick={() => handleUpdateStatus(menuItem?.value)}>
                                                {menuItem.text}
                                            </MenuItem>
                                        ))}
                                    </Menu>
                                </div>
                            </div>
                            <div>
                                <span
                                    style={{
                                        fontSize: '12px',
                                        fontWeight: '500',
                                        width: '300px',
                                        height: 'auto',
                                    }}
                                >
                                    📅 {GetLeadsData?.date} {format12HourTime(GetLeadsData?.time)} @ {GetLeadsData?.meeting_location}
                                </span>
                            </div>
                            <div>
                                <span
                                    style={{
                                        display: 'block',
                                        fontSize: '12px',
                                        fontWeight: '500',
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                    }}
                                >
                                    {GetLeadsData?.buyer_max_price ? `💵: $${GetLeadsData?.buyer_max_price}.00 USD` : '💵: $0.00'} <br />
                                    📅:{formattedDate}
                                </span>
                            </div>

                            <div style={{ display: 'flex', gap: '10px', marginTop: '10px' }}>
                                <Button
                                    style={{
                                        width: '162px',
                                        height: '39px',
                                        backgroundColor: 'white',
                                        fontSize: '14px',
                                        borderRadius: '14px',
                                        border: ' 1px solid #587DBF',
                                        color: '#587DBF',
                                    }}
                                >
                                    ICNT-{GetLeadsData?.id}
                                </Button>
                                <div>
                                    <Button
                                        style={{
                                            width: '127px',
                                            height: '38px',
                                            fontSize: '14px',
                                            backgroundColor: 'white',
                                            fontWeight: '500',
                                            borderRadius: '14px',
                                            border: ' 1px solid #587DBF',
                                            color: '#587DBF',
                                        }}
                                    >
                                        {GetLeadsData?.lead_type}
                                    </Button>
                                </div>
                                {GetLeadsData?.source === null ? null : (
                                    <div>
                                        <Button
                                            style={{
                                                width: 'auto',
                                                height: '39px',
                                                backgroundColor: 'white',
                                                fontSize: '14px',
                                                borderRadius: '14px',
                                                border: ' 1px solid #587DBF',
                                                color: '#587DBF',
                                            }}
                                        >
                                            From {GetLeadsData?.source}
                                        </Button>
                                    </div>
                                )}
                            </div>
                        </Box>

                        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '30px' }}>
                            <div style={{ display: 'flex', flexWrap: 'wrap', width: '400px' }}>
                                <div style={{ flex: 1, width: '250px' }}>
                                    <div style={{ display: 'flex', gap: '2px', flexWrap: 'wrap' }}>
                                        {tagsOne.length > 0 ? (
                                            tagsOne?.map((tag, index) => (
                                                <Chip
                                                    key={index}
                                                    label={tag}
                                                    sx={{ border: '1px solid #587dbf', color: '#587dbf', fontSize: '10px', background: 'transparent' }} // Add margin for spacing
                                                />
                                            ))
                                        ) : (
                                            <p></p>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div style={{ display: 'flex', gap: '25px' }}>
                                {GetLeadsData?.phone !== null ? (
                                    <BsTelephoneFill
                                        style={{ fontSize: '18px', marginTop: '4px', cursor: 'pointer', color: 'black' }}
                                        onClick={() => setShowPhoneNumber(!showPhoneNumber)}
                                        title="Click to show phone number (if available)"
                                    />
                                ) : (
                                    <>
                                        <AddIcCallIcon
                                            style={{ fontSize: '22px', marginTop: '4px', cursor: 'pointer', color: 'black' }}
                                            onClick={handleIconClick}
                                            title="Click to show phone number (if available)"
                                        />
                                    </>
                                )}
                                {showPhoneNumber && <span style={{ marginTop: '10px', fontSize: '12px' }}>{GetLeadsData?.phone}</span>}
                                <Modal
                                    open={openNullModal}
                                    onClose={() => setOpenNullModal(false)}
                                    aria-labelledby="modal-modal-title"
                                    aria-describedby="modal-modal-description"
                                >
                                    <div
                                        style={{
                                            position: 'absolute',
                                            top: '50%',
                                            left: '50%',
                                            transform: 'translate(-50%, -50%)',
                                            backgroundColor: '#fff',
                                            padding: '20px',
                                            borderRadius: '10px',
                                            width: 'auto',
                                            height: 'auto',
                                            overflow: 'auto',
                                        }}
                                    >
                                        <IconButton
                                            style={{ position: 'absolute', top: '0px', right: '20px' }}
                                            onClick={() => setOpenNullModal(false)}
                                        >
                                            <CloseIcon />
                                        </IconButton>

                                        <div style={{ width: '300px', marginTop: '20px', position: 'relative' }}>
                                            <Box style={{ display: 'grid', gap: '21px' }}>
                                                <Box style={{ display: 'flex', justifyContent: 'center' }}>
                                                    <Typography style={{ fontSize: '19px', fontWeight: '700' }}>Add Phone</Typography>
                                                </Box>
                                                <Box>
                                                    <TextField
                                                        fullWidth
                                                        multiline
                                                        placeholder="Please add phone.."
                                                        style={{
                                                            fontSize: '10px',
                                                            color: '#6E757C',
                                                        }}
                                                        InputProps={{
                                                            style: {
                                                                height: '45px',
                                                                width: '297px',
                                                            },
                                                        }}
                                                    />
                                                </Box>
                                                <Box>
                                                    <Button
                                                        style={{
                                                            width: '297px',
                                                            padding: '8px',
                                                            borderRadius: '10px',
                                                            fontSize: '19px',
                                                            border: 'none',
                                                            color: 'black',
                                                            backgroundColor: '#efefef',
                                                        }}
                                                    >
                                                        Add
                                                    </Button>
                                                </Box>
                                            </Box>
                                        </div>
                                    </div>
                                </Modal>
                                <a href={gmailComposeUrl} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                                    <MdEmail style={{ fontSize: '23px', cursor: 'pointer', color: 'black' }} title="Compose email in Gmail" />
                                </a>
                            </div>
                        </div>
                        {/* assignment section */}
                        {GetLeadsData?.assign == 0 ? (
                            <>
                                <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'center' }}>
                                    {/* {GetLeadsData?.status === "new" && !GetLeadsData?.email ? (
                                            <Button
                                                disabled
                                                style={{
                                                    width: '720px',
                                                    padding: '8px',
                                                    borderRadius: '10px',
                                                    fontSize: '19px',
                                                    border: 'none',
                                                    color: 'white',
                                                    backgroundColor: '#9a9a9a',
                                                }}
                                            >
                                                PLEASE ADD EMAIL
                                            </Button>
                                        ) : ( */}
                                    <Button
                                        onClick={handleClickOpenLocationModel}
                                        style={{
                                            width: '720px',
                                            padding: '8px',
                                            borderRadius: '10px',
                                            fontSize: '19px',
                                            border: 'none',
                                            color: 'white',
                                            backgroundColor: '#9a9a9a',
                                        }}
                                    >
                                        SEND INVITE TO AGENTS
                                    </Button>
                                    {/* )} */}
                                </div>
                            </>
                        ) : GetLeadsData?.assign == 1 && GetLeadsData?.assignby?.id == LoginUserId ? (
                            <>
                                <div>
                                    <Card className={classes.card}>
                                        <CardContent>
                                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                {/* right section */}
                                                <div style={{ display: 'grid' }}>
                                                    <span style={{ fontSize: '12px', fontWeight: '500', color: 'white' }}>Assigned By</span>
                                                    <span style={{ fontSize: '16px', color: 'white', fontWeight: '700' }}>
                                                        {GetLeadsData?.assignby?.name}
                                                    </span>
                                                </div>
                                                {/* left section */}
                                                <div style={{ display: 'grid' }}>
                                                    <div>
                                                        <div style={{ display: 'flex', gap: '10px', marginLeft: '127px' }}>
                                                            <div
                                                                style={{
                                                                    background: 'white',
                                                                    height: '28px',
                                                                    borderRadius: '10px',
                                                                    padding: '2px',
                                                                }}
                                                            ></div>
                                                            <img
                                                                src={user_icon}
                                                                alt=""
                                                                style={{ width: '27px', height: '24px', borderRadius: '100px' }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <span style={{ color: 'white' }}>6 Feb 2024, 9.00 AM - 10.00 AM</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </CardContent>
                                    </Card>
                                </div>
                                <div style={{ marginTop: '12px' }}>
                                    <Button
                                        onClick={() => handleRequestedAgents(GetLeadsData?.id)}
                                        style={{
                                            width: '720px',
                                            padding: '8px',
                                            borderRadius: '10px',
                                            fontSize: '19px',
                                            border: 'none',
                                            color: 'white',
                                            backgroundColor: 'gray',
                                        }}
                                    >
                                        VIEW INVITATION
                                    </Button>
                                </div>
                            </>
                        ) : (
                            <>
                                {/* <div>
                                        <Typography style={{ fontSize: '22px', fontWeight: 'bold' }}>Communication Section</Typography>
                                        <Card style={{ width: '720px', borderRadius: '22px', boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px' }}>
                                            <CardContent>
                                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                    <Box style={{ display: 'grid', gap: '10px' }}>
                                                        <Box style={{ display: 'flex', gap: '10px' }}>
                                                            <Box>
                                                                <Avatar
                                                                    alt="AI"
                                                                    src={`https://iconnctapp.com/` + GetLeadsData?.assignby?.profile_image}
                                                                />
                                                            </Box>
                                                            <Box style={{ marginTop: '10px' }}>{GetLeadsData?.assignby?.name}{' '}{GetLeadsData?.assignby?.last_name}</Box>
                                                        </Box>

                                                        <Box style={{ display: 'flex', gap: '10px' }}>
                                                            <Box>
                                                                <Avatar
                                                                    src={`https://iconnctapp.com/` + GetLeadsData?.assignto?.profile_image}
                                                                />
                                                            </Box>
                                                            <Box style={{ marginTop: '10px' }}>{GetLeadsData?.assignto?.name} {' '}{GetLeadsData?.assignto?.last_name}</Box>
                                                        </Box>

                                                        <Box style={{ display: 'flex', gap: '10px' }}>
                                                            <Box>
                                                                <Avatar alt="Remy Sharp" src={logo_between} />
                                                            </Box>
                                                            <Box style={{ marginTop: '10px' }}>Shaw Tong</Box>
                                                        </Box>
                                                    </Box>
                                                    <Box>
                                                        <ChatModule
                                                            icaImage={GetLeadsData?.assignby?.profile_image}
                                                            leadImge={GetLeadsData?.assignto?.profile_image}
                                                            leadId={GetLeadsData?.id}
                                                            status={GetLeadsData?.status}
                                                            buyer_latitude={GetLeadsData?.buyer_latitude}
                                                            buyer_longitude={GetLeadsData?.buyer_longitude}
                                                            name={`${GetLeadsData?.first_name} ${GetLeadsData?.last_name}`}
                                                        />
                                                    </Box>
                                                </div>
                                            </CardContent>
                                        </Card>
                                    </div> */}

                                <div style={{ marginTop: '6px' }}>
                                    <div>
                                        <span style={{ fontSize: '24px', fontWeight: 'bold', color: '#333' }}>Assignment Section</span>
                                    </div>
                                    {/* AssignBY section card */}
                                    <div>
                                        <Card
                                            style={{
                                                width: '720px',
                                                height: '90px',
                                                borderRadius: '22px',
                                                background: 'rgb(240, 248, 255)',
                                                boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                                            }}
                                            className={classes.card}
                                        >
                                            <CardContent>
                                                <div style={{ display: 'flex', justifyContent: 'space-between', padding: '5px' }}>
                                                    {/* Right section */}
                                                    <div style={{ display: 'grid' }}>
                                                        <span style={{ fontSize: '16px', fontWeight: '500', color: '#333' }}>
                                                            Assigned By:{' '}
                                                            <span style={{ fontSize: '14px', color: 'white', fontWeight: '400' }}>
                                                                {GetLeadsData?.assignby?.name} {GetLeadsData?.assignby?.last_name}
                                                            </span>
                                                        </span>
                                                        <span style={{ fontSize: '16px', fontWeight: '500', color: '#333' }}>
                                                            Assigned To:{' '}
                                                            <span style={{ fontSize: '14px', color: 'white', fontWeight: '400' }}>
                                                                {GetLeadsData?.assignto?.name} {GetLeadsData?.assignto?.last_name}
                                                            </span>{' '}
                                                        </span>
                                                    </div>
                                                    {/* Left section */}
                                                    {GetLeadsData?.status !== 'active' || GetLeadsData?.assignby?.id === LoginUserId ? (
                                                        <div style={{ display: 'grid' }}>
                                                            <div style={{ display: 'flex', gap: '10px', marginLeft: '127px' }}>
                                                                {!(GetLeadsData?.status === 'rejected' || GetLeadsData?.status === 'closed') && (
                                                                    <>
                                                                        <div
                                                                            style={{
                                                                                background: 'white',
                                                                                height: '28px',
                                                                                borderRadius: '10px',
                                                                                padding: '2px',
                                                                                border: '1px solid #119311',
                                                                                display: 'flex',
                                                                                alignItems: 'center',
                                                                                cursor: 'pointer',
                                                                            }}
                                                                            onClick={handleClickOpenLocationModel}
                                                                        >
                                                                            <span
                                                                                style={{ fontSize: '15px', color: '#119311', padding: '0 5px' }}
                                                                            >
                                                                                Reassign
                                                                            </span>
                                                                        </div>

                                                                        <Chip
                                                                            onClick={handleClickOpenMeetingModel}
                                                                            label="Edit Meeting"
                                                                            icon={<EditIcon sx={{ color: 'white' }} />} // Apply the color here
                                                                            sx={{
                                                                                background: 'transparent',
                                                                                border: '1px solid white',
                                                                                borderRadius: '12px',
                                                                                color: 'white',
                                                                            }}
                                                                        />
                                                                    </>
                                                                )}
                                                                <img
                                                                    src={`https://iconnctapp.com/` + GetLeadsData?.assignto?.profile_image}
                                                                    alt=""
                                                                    style={{ width: '27px', height: '24px', borderRadius: '50%' }} // Ensure it's circular
                                                                />
                                                            </div>
                                                            <div>
                                                                <span style={{ color: '#666', fontSize: '14px' }}>
                                                                    {/* 6 Feb 2024, 9.00 AM - 10.00 AM */}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </CardContent>
                                        </Card>
                                    </div>
                                </div>
                            </>
                        )}

                        {/* Note */}
                        <div style={{ display: 'grid', marginTop: '5px', borderRadius: '22px', overflow: 'hidden' }}>
                            <div>
                                <span style={{ color: '#606060', fontWeight: 'bold', fontSize: '16px' }}>
                                    <NoteAltIcon style={{ marginRight: '4px' }} />
                                    Notes
                                </span>
                            </div>

                            <div>
                                <Card
                                    style={{
                                        width: '714px',
                                        background: 'rgb(207, 227, 244)',
                                        border: '3px solid #192ea669',
                                        borderRadius: '22px', // Updated border radius
                                        padding: '10px', // Increased padding for better spacing
                                        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)', // Added shadow for depth
                                    }}
                                >
                                    {displayNotes.length > 0 && (
                                        <>
                                            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                <FilterListIcon onClick={(e) => setMenuAnchor(e.currentTarget)} sx={{ cursor: 'pointer' }} />
                                                <Menu
                                                    transformOrigin={{
                                                        vertical: 'top',
                                                        horizontal: 'right',
                                                    }}
                                                    anchorEl={menuAnchor}
                                                    open={Boolean(menuAnchor)}
                                                    onClose={() => setMenuAnchor(null)}
                                                >
                                                    <MenuItem onClick={() => handleSort('asc')}>Ascending</MenuItem>
                                                    <MenuItem onClick={() => handleSort('desc')}>Descending</MenuItem>
                                                </Menu>
                                            </div>
                                        </>
                                    )}
                                   <CardContent>
                                        {displayNotes?.map((note, index) => {
                                                // Ensure createTime exists and is valid before processing
                                                if (note.createTime) {
                                                    // Split the createTime string into date and time components
                                                    const [datePart, timePart] = note.createTime.split('T');

                                                    // Extract year, month, and day from the date part
                                                    const [year, month, day] = datePart.split('-');

                                                    // Extract hour and minute from the time part
                                                    const [hour, minute] = timePart.substring(0, 5).split(':');

                                                    // Format date and time
                                                    const formattedDate = `${day}-${month}-${year}`;
                                                    const formattedTime = `${hour}:${minute}`;

                                                    // Combine date and time into desired format
                                                    const formattedCreateTime = `${formattedDate}  ${formattedTime}`;
                                                    const repliesToShow = showAllReplies ? note?.replies : note?.replies?.slice(0, 1);
                                                    return (
                                                        <div
                                                            key={note.id ?? index}
                                                            style={{
                                                                marginBottom: '10px',
                                                                display: 'grid',
                                                                // gridTemplateColumns: '1fr auto',
                                                                alignItems: 'center',
                                                                background: 'white',
                                                                borderRadius: '10px',
                                                                padding: '10px',
                                                            }}
                                                        >
                                                            <div>
                                                                <div style={{ color: '#000000b0', fontWeight: 'bold' }}>{note?.creatorName}</div>
                                                                <div style={{ color: '#726b6b', gridColumn: '1 / span 2' }}>{note?.content}</div>
                                                                <div style={{ color: '#726b6b', textAlign: 'right' }}>{formattedCreateTime}</div>
                                                            </div>
                                                            <div>
                                                                {/* Display Replies */}
                                                                {note?.replies?.length > 0 && (
                                                                    <div style={{ marginTop: '10px' }}>
                                                                        <span
                                                                            style={{
                                                                                marginTop: '5px',
                                                                                color: '#007BFF',
                                                                                background: 'none',
                                                                                cursor: 'pointer',
                                                                                fontSize: '14px',
                                                                                fontWeight: 'bold',
                                                                            }}
                                                                        >
                                                                            Replies
                                                                        </span>
                                                                        {repliesToShow?.map((reply, replyIndex) => {
                                                                            const [replyDatePart, replyTimePart] = reply.created_at.split('T');
                                                                            const [replyYear, replyMonth, replyDay] = replyDatePart.split('-');
                                                                            const [replyHour, replyMinute] = replyTimePart.substring(0, 5).split(':');
                                                                            const formattedReplyTime = `${replyDay}-${replyMonth}-${replyYear} ${replyHour}:${replyMinute}`;
                                                                            return (
                                                                                <div key={reply?.id ?? replyIndex} style={{ marginTop: '5px' }}>
                                                                                    <div style={{ fontWeight: 'bold', color: '#444' }}>
                                                                                        {reply.creatorName}
                                                                                    </div>
                                                                                    <div style={{ color: '#555' }}>{reply.reply}</div>
                                                                                    <div style={{ fontSize: '12px', color: '#888' }}>
                                                                                        {formattedReplyTime}
                                                                                    </div>
                                                                                </div>
                                                                            );
                                                                        })}
                                                                        {/* Show More / Show Less Button */}
                                                                        {note?.replies?.length > 1 && (
                                                                            <button
                                                                                onClick={() => setShowAllReplies(!showAllReplies)}
                                                                                style={{
                                                                                    marginTop: '5px',
                                                                                    color: '#007BFF',
                                                                                    background: 'none',
                                                                                    border: 'none',
                                                                                    cursor: 'pointer',
                                                                                    fontSize: '14px',
                                                                                    padding: '0',
                                                                                }}
                                                                            >
                                                                                {showAllReplies ? 'Show Less' : 'Show More'}
                                                                            </button>
                                                                        )}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    );
                                                } else {
                                                    // Handle the case where createTime is undefined or invalid
                                                    return (
                                                        <div
                                                            key={note.id ?? index}
                                                            style={{
                                                                marginBottom: '10px',
                                                                display: 'grid',
                                                                gridTemplateColumns: '1fr auto',
                                                                alignItems: 'center',
                                                                background: 'white',
                                                                borderRadius: '10px',
                                                                padding: '10px',
                                                            }}
                                                        >
                                                            <div style={{ color: '#000000b0', fontWeight: 'bold' }}>{note?.creatorName}</div>
                                                            <div style={{ color: '#726b6b', gridColumn: '1 / span 2' }}>{note?.content}</div>
                                                            {/* <div style={{ color: '#726b6b', textAlign: 'right' }}>Invalid Date/Time</div> */}
                                                        </div>
                                                    );
                                                }
                                            })}
                                        </CardContent>
                                </Card>
                            </div>

                            <div>
                                <TextField
                                    fullWidth
                                    multiline
                                    placeholder="Enter notes here..."
                                    name="description"
                                    value={notes}
                                    onChange={(e) => setNotes(e.target.value)}
                                    rows={2}
                                    style={{
                                        fontSize: '14px',
                                        color: '#6E757C',
                                        marginTop: '2%',
                                        borderRadius: '12px', // Added border radius to TextField
                                        padding: '8px',
                                        // backgroundColor: '#f7f7f7', 
                                    }}
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            borderRadius: '12px',
                                        },
                                    }}
                                />
                            </div>

                            <div
                                style={{
                                    marginTop: '10px',
                                    display: 'flex',
                                    justifyContent: 'center',
                                }}
                            >
                                <Button
                                    onClick={() => handleAgentInternalNote(GetLeadsData?.id, notes)}
                                    style={{
                                        width: '700px',
                                        padding: '8px',
                                        borderRadius: '10px',
                                        fontSize: '19px',
                                        border: '1px solid #587DBF',
                                        backgroundColor: 'white',
                                        color: '#587DBF',
                                        marginBottom: '12px',
                                        transition: 'background-color 0.3s', // Smooth transition for hover
                                    }}
                                    onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#e3f2fd')}
                                    onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'white')}
                                >
                                    Add Notes
                                </Button>
                            </div>
                        </div>
                    </DialogContent>

                </BootstrapDialog>
            )}

            <Dialog
                aria-labelledby="customized-dialog-title"
                open={openLocation}
                // onClose={CloseLocation}
                sx={{
                    '& .MuiPaper-root': {
                        borderRadius: '22px',
                        boxShadow: '0px 10px 20px rgba(0, 0, 0, 0.15)', // Modern shadow
                    },
                }}
            >
                <DialogTitle sx={{ m: 0, p: 2, textAlign: 'center' }} id="customized-dialog-title">
                    <img src={logoICA} style={{ width: '220px', display: 'flex', justifyContent: 'flex-start' }} alt="Logo" />
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleCloseLocation}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent dividers sx={{ padding: '20px 40px' }}>
                    <Typography variant="subtitle2" sx={{ color: '#6C757D', marginBottom: '20px' }}>
                        <em>Select Appointment Date and Time</em>
                    </Typography>
                    <Box sx={{ display: 'flex', gap: '20px', marginBottom: '30px' }}>
                        {/* Date Picker */}
                        <Box sx={{ flex: 1 }}>
                            <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#343A40' }}>
                                Date
                            </Typography>
                            <TextField
                                margin="dense"
                                type="date"
                                value={selectedDate}
                                onChange={handleChangeDate}
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                                InputProps={{
                                    style: { height: '48px', borderRadius: '12px' },
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <EventIcon style={{ color: '#343A40' }} />
                                        </InputAdornment>
                                    ),
                                }}
                                inputProps={{
                                    min: tomorrowsDate,
                                }}
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        borderRadius: '12px',
                                        borderColor: '#DEE2E6',
                                    },
                                }}
                            />
                        </Box>
                        {/* Time Picker */}
                        <Box sx={{ flex: 1 }}>
                            <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#343A40' }}>
                                Time
                            </Typography>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                {/* <DemoContainer components={['TimePicker']}> */}
                                <TimePicker
                                    value={selectTime}
                                    onChange={handleTimeChange}
                                    sx={{
                                        width: '100%',
                                        '.MuiOutlinedInput-root': {
                                            borderRadius: '12px',
                                            height: '48px',
                                            marginTop: '9px',
                                            borderColor: '#DEE2E6',
                                        },
                                    }}
                                    // minTime={dayjs()}
                                    componentsProps={{
                                        actionBar: {
                                            actions: ['accept', 'clear', 'cancel'],
                                        },
                                    }}
                                />
                                {/* </DemoContainer> */}
                            </LocalizationProvider>
                        </Box>
                    </Box>

                    {/* Location Preference */}
                    <Typography variant="subtitle2" sx={{ color: '#6C757D', marginBottom: '10px' }}>
                        <em>Select Location Preference</em>
                    </Typography>
                    <FormControl sx={{ marginBottom: '20px' }}>
                        <RadioGroup
                            aria-labelledby="demo-controlled-radio-buttons-group"
                            name="controlled-radio-buttons-group"
                            value={assignRadio}
                            onChange={hanldeAssignRadio}
                            row
                        >
                            <FormControlLabel value="1" control={<Radio />} label="Preferred Location" />
                            <FormControlLabel value="0" control={<Radio />} label="Nearest" />
                        </RadioGroup>
                    </FormControl>
                    {/* Preferred Regions Autocomplete */}
                    {assignRadio === '1' && (
                        <Autocomplete
                            value={PreferredRegions?.find((option) => option.id === selectedLocation) || null}
                            getOptionLabel={(option) => option?.region_name}
                            onChange={(event, newValue) => {
                                setSelectedLocation(newValue ? newValue?.id : '');
                            }}
                            options={PreferredRegions}
                            sx={{
                                width: 480,
                                marginBottom: '10px',
                                '& .MuiOutlinedInput-root': {
                                    borderRadius: '12px',
                                },
                            }}
                            renderInput={(params) => <TextField {...params} label="Select Preferred Location" sx={{ borderRadius: '12px' }} />}
                        />
                    )}

                    <Box>
                        <Autocomplete
                            multiple
                            id="tags-autocomplete"
                            options={tags}
                            disableCloseOnSelect
                            getOptionLabel={(option) => option?.title || 'No title available'}
                            onChange={handleChangeTags}
                            value={tags.filter((tag) => selectedTags.includes(tag.title))}
                            renderOption={(props, option, { selected }) => (
                                <li key={option?.id} {...props}>
                                    <Checkbox style={{ marginRight: 8 }} checked={selected} />
                                    {option?.title}
                                </li>
                            )}
                            renderInput={(params) => <TextField {...params} label="Tags" placeholder="Select tags" />}
                            sx={{
                                width: 480,
                                marginBottom: '10px',
                                '& .MuiOutlinedInput-root': {
                                    borderRadius: '12px',
                                },
                            }}
                        />
                    </Box>
                    {/* Google Places Autocomplete */}
                    <Typography variant="subtitle2" sx={{ color: '#6C757D', marginBottom: '10px' }}>
                        <em>Select Meeting Location*</em>
                    </Typography>
                    <Box sx={{ marginBottom: '20px' }}>
                        <GooglePlacesAutocomplete
                            selectProps={{
                                value: googleLocation,
                                onChange: (value) => handlePlaceSelect(value),
                            }}
                            apiKey={import.meta.env.VITE_GOOGLE_API_KEY}
                        />
                    </Box>

                    {/* Find Agent Button */}
                    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                        <Button
                            onClick={() =>
                                handleFindNearestAgents(selectedLocation, GetLeadsData?.id, googleLocation?.label, latitude, longitude, selectedTags)
                            }
                            sx={{
                                width: '100%',
                                padding: '12px',
                                fontSize: '18px',
                                borderRadius: '22px',
                                backgroundColor: '#9a9a9a',
                                color: 'white',
                                '&:hover': {
                                    backgroundColor: '#495057',
                                },
                            }}
                        >
                            FIND THE AGENT
                        </Button>
                    </Box>
                </DialogContent>
            </Dialog>

            {/* Required Notes if Change Status */}
            <Modal open={saveNoteModel} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                <div
                    style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        backgroundColor: '#fff',
                        padding: '20px',
                        borderRadius: '22px', // Increased border-radius
                        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.2)', // Added shadow for depth
                        width: '90%', // Responsive width
                        maxWidth: '500px', // Maximum width for larger screens
                        height: 'auto',
                        overflow: 'auto',
                    }}
                >
                    <IconButton style={{ position: 'absolute', top: '10px', right: '10px' }} onClick={handleNoteModalClose}>
                        <CloseIcon />
                    </IconButton>
                    <Typography id="modal-modal-title" variant="h6" component="h2" style={{ fontWeight: 'bold', marginBottom: '15px' }}>
                        Add a reasons, why are you changing status to &quot;{formattedStatusValue}&quot;
                    </Typography>
                    <Typography id="modal-modal" component="h4" style={{ marginBottom: '10px', fontSize: '12px' }}>
                        Note: Please add DATE/TIME and Note
                    </Typography>
                    <TextField
                        fullWidth
                        multiline
                        name="description"
                        value={saveNoteStatus}
                        placeholder="write message.."
                        onChange={(e) => setSaveNoteModelStatus(e.target.value)}
                        rows={4}
                        variant="outlined" // Added variant for consistent style
                        style={{
                            fontSize: '14px', // Increased font size for better readability
                            color: '#6E757C',
                            marginBottom: '15px', // Margin below the text field
                            borderRadius: '12px', // Rounded corners for the text field
                        }}
                    />
                    {/* Add notes */}
                    <Button
                        onClick={() => handleUpdateStatus(updateStatusValue)}
                        style={{
                            width: '100%', // Full width for better alignment
                            padding: '10px',
                            borderRadius: '12px', // Consistent border radius
                            fontSize: '16px', // Adjusted font size
                            border: '1px solid #587DBF',
                            backgroundColor: '#587DBF', // Changed to a solid background color for emphasis
                            color: '#fff', // White text for better contrast
                            transition: 'background-color 0.3s', // Smooth transition for hover effect
                        }}
                        onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#4B6F9D')}
                        onMouseOut={(e) => (e.currentTarget.style.backgroundColor = '#587DBF')}
                    >
                        ADD
                    </Button>
                </div>
            </Modal>

            <UpdateIcaMeeting
                openMeetingModal={openMeetingModal}
                setOpenMeetingModal={setOpenMeetingModal}
                leadMeetingId={GetLeadsData?.id}
                leadAddress={GetLeadsData?.display_address}
                buyerLatitude={GetLeadsData?.buyer_latitude}
                buyerLongitude={GetLeadsData?.buyer_longitude}
                leadDate={GetLeadsData?.date}
                leadTime={GetLeadsData?.time}
            />
        </>
    );
};
export default CustomerLeadProfile;
